import { useEffect } from "react";

/** Forwards to an external URL, keeping query parameters and hash. */
export const ExternalRedirect = ({ to }: { to: string }) => {
  useEffect(() => {
    const target = new URL(to);
    new URLSearchParams(window.location.search).forEach((value, key) => {
      target.searchParams.append(key, value);
    });
    if (window.location.hash) target.hash = window.location.hash;
    window.location.replace(target.toString());
  }, [to]);
  return null;
};
